module.exports = __webpack_public_path__ + "static/media/IndianaJones.5606db0f.jpg";